import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';

import { theme } from '_constants/theme';

const { colors, devices, fontSizes, spaces } = theme;

const StyledStepperContainer = styled.div`
  display: none;

  @media ${devices.tablet} {
    display: flex;
    flex-direction: column;
  }
`;

const StyledStepContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  ${({ reverse }) =>
    reverse &&
    css`
      flex-direction: row-reverse;
    `}
`;

const StyledImageContainer = styled.div`
  margin-bottom: ${spaces.regular + 2}px;

  img {
    max-width: 162px;
  }
`;

const StyledStepInfo = styled.div`
  flex-grow: 1;
  padding-left: ${spaces.regular}px;
  padding-right: ${spaces.regular}px;
  margin-bottom: ${spaces.regular}px;
`;

const StyledTitle = styled.div`
  margin-bottom: ${spaces.smallX}px;
  font-family: 'Aeonik';
  font-style: normal;
  font-weight: 500;
  font-size: ${fontSizes.small}px;
  line-height: 130%;
  text-align: center;
  color: ${colors.gray[600]};
`;

const StyledSubtitle = styled.div`
  margin-bottom: ${spaces.smallX}px;
  font-family: 'Aeonik';
  font-style: normal;
  font-weight: 500;
  font-size: ${fontSizes.medium}px;
  line-height: 130%;
  text-align: center;
  color: ${colors.gray[800]};
`;

const StyledDescription = styled.div`
  margin-bottom: ${spaces.smallX}px;
  font-family: 'Aeonik';
  font-style: normal;
  font-weight: 400;
  font-size: ${fontSizes.regular}px;
  text-align: center;
  color: ${colors.gray[700]};
`;

const InfoStepperMobile = ({ steps = [] }) => (
  <StyledStepperContainer>
    {steps.map(({ title, subtitle, description, imageSrc, imageAlt }, idx) => (
      <StyledStepContainer key={`${title}:${idx}`}>
        <StyledImageContainer>
          <picture>
            <source srcSet={imageSrc} type="image/svg+xml" />
            <img src={imageSrc} title={imageAlt} alt={imageAlt} />
          </picture>
        </StyledImageContainer>
        <StyledStepInfo>
          <StyledTitle>{title}</StyledTitle>
          <StyledSubtitle>{subtitle}</StyledSubtitle>
          <StyledDescription>{description}</StyledDescription>
        </StyledStepInfo>
      </StyledStepContainer>
    ))}
  </StyledStepperContainer>
);

InfoStepperMobile.propTypes = {
  steps: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.node,
      subtitle: PropTypes.node,
      description: PropTypes.node,
      imageSrc: PropTypes.string,
      imageAlt: PropTypes.string,
    })
  ),
};

export default InfoStepperMobile;
